import { Component, OnInit } from '@angular/core';
import { MongoService } from 'src/app/services/mongo.service';
import { NavigatorService } from 'src/app/services/navigator.service';
import { StateService } from 'src/app/services/state.service';

@Component({
  selector: 'view-rewards',
  templateUrl: './view-rewards.component.html',
  styleUrl: './view-rewards.component.css'
})
export class ViewRewardsComponent implements OnInit {
  rewardsData: any[] = [];

  constructor(
    private navigator: NavigatorService,
    private mongoService: MongoService,
    private stateService: StateService
  ){}

  public async ngOnInit(): Promise<void> {
    this.rewardsData = [];
    if(this.stateService.getState() == 'state-pumps'){
      this.rewardsData = await this.mongoService.getAllPumpsPrizesData();
    } else if(this.stateService.getState() == 'state-airconditioners'){ 
      this.rewardsData = await this.mongoService.getAllAirconditionersPrizesData();
    }    
  }

  public redirectToAdministrationScreen() : void {
    this.navigator.redirectToAdministrationScreen();
  }
}
